var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePasswordHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EEF1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99942 11.0196L4.99943 11.0197L4.99942 11.0197C5.00457 11.0755 5.02002 11.1311 5.04577 11.1818C5.42641 11.9511 5.92462 12.6557 6.51811 13.2746L4.96094 15.6104L5.70978 16.1096L7.18353 13.899C7.82761 14.4426 8.55535 14.897 9.34587 15.2426L8.08581 18.1827L8.91304 18.5372L10.1884 15.5614C10.9356 15.8021 11.7277 15.9493 12.5494 15.9887V18.86H13.4494V15.9886C14.2704 15.9489 15.0624 15.8014 15.81 15.5604L17.0858 18.5372L17.913 18.1827L16.6525 15.2415C17.4435 14.8958 18.1721 14.4413 18.817 13.8976L20.2917 16.1096L21.0405 15.6104L19.4828 13.2737C20.0769 12.6551 20.5756 11.9508 20.956 11.1818C20.9732 11.1466 20.9851 11.1092 20.9919 11.0708C20.9957 11.0496 20.9979 11.0281 20.9985 11.0066L20.9986 10.9946V10.9945H20.0593C18.7553 13.449 16.0907 15.1442 12.9984 15.1442C9.90077 15.1442 7.24652 13.449 5.94247 10.9945L4.99942 11.0196Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordHover);
export default __webpack_public_path__ + "static/media/hide-password-hover.9f081f49.svg";
export { ForwardRef as ReactComponent };